<div class="searchresult">
	<his-search-form-result
	    #SearchFormResultComponent
		[searchConfigFile]="'fs/res/searchPublicationCreator.xml'"
		[selectedOptions]="selectedOptions"
		[selectedOptionsIdColumn]="'Person.id'"
        [genericSearchRowTooltipId]="'CONCAT2(Person.firstname,\' \',Person.surname)'"
		[resultRowsPerPage]="10"
		[singleSelect]="true"
		[isSearchPopup]="true"
		[hisIcon]="'arrow_right'"
		[presetInputFields]="presetInputFields"
		[customResultRowsTemplate]="noInternalPersonTemplate"
		(onSubmitSelection)="setPerson($event)">
	</his-search-form-result>
	
	<ng-template #noInternalPersonTemplate let-numberOfVisibleDataColumns="numberOfVisibleDataColumns">
		<tr>
	       	<td class="singleSelectColumn">
	       		<button (click)="selectNoInternalPerson()" hisImage="arrow_right" class="icon" [title]="'fs.res.publication.creators.wizard.person.notInternalPersonSelection' | hisUi"></button>
			</td>
	
			<td attr.colspan="{{ numberOfVisibleDataColumns }}">{{'fs.res.publication.creators.wizard.person.notInternalPerson' | hisUi}}</td>
		</tr>
	</ng-template>
</div>
